import { model } from "../core/model";
import { Config } from "../core/config"
import {logo, logo_mobile} from './logo'


const nav = () => {
        return /*html*/`
                        <a class="event-track nav__logo" data-label="logo header" href="http://www.lanacion.com.ar">
                            ${logo()}${logo_mobile()}
                        </a>
                        <div class="nav-login">
                            ${(model.Usuario.isLoggued() && model.Usuario.UsuarioUsuario) ?
                                    /*html*/`<p>
                                                <a href="${Config.dominioMiCuenta}">${model.Usuario.Email}</a>
                                                    ${(model.Usuario.hasDigitalSuscription()) ?
                                                            /*html*/`<span class="chapita-conSuscrip">SUSCRIPTOR DIGITAL</span>`
                                                    :                                      
                                                            /*html*/`<span class="chapita-sinSuscrip">SIN SUSCRIPCI&Oacute;N DIGITAL</span>`}
                                                <a href="#" class="next-button nav-login__cambiar" data-step="logout">Cambiar cuenta</a>
                                            </p>`
                                    :
                                    /*html*/`<p>&iquest;Ya sos suscriptor digital? 
                                                <a href="#" class="next-button" data-step="ya_tenes_suscripcion">
                                                    Ingres&aacute;
                                                </a>
                                            </p>`}
                        </div>`
}

const nav_embed = () => {
    return /*html*/`
                    ${logo_mobile()}
                    <div class="nav-login">
                        ${(model.Usuario.isLoggued() && model.Usuario.UsuarioUsuario) ?
                                /*html*/`<p>
                                            <span>${model.Usuario.Email}</span>
                                                ${(model.Usuario.hasDigitalSuscription()) ?
                                                        /*html*/`<span class="chapita-conSuscrip">SUSCRIPTOR DIGITAL</span>`
                                                :                                      
                                                        /*html*/`<span class="chapita-sinSuscrip">SIN SUSCRIPCI&Oacute;N DIGITAL</span>`}
                                        </p>`
                                :
                                /*html*/`<p>&iquest;Ya sos suscriptor digital? 
                                            <a href="#" class="next-button" data-step="ya_tenes_suscripcion">
                                                Ingres&aacute;
                                            </a>
                                        </p>`}
                    </div>`
}

module.exports = { 
    nav :nav,
    nav_embed: nav_embed
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/nav.js